// assets
import IconRating from "src/img/survey/icons/star.webp";
import IconSatisfactionBad from "src/img/survey/icons/bad.webp";
import IconSatisfactionPoor from "src/img/survey/icons/poor.webp";
import IconSatisfactionOk from "src/img/survey/icons/ok.webp";
import IconSatisfactionGreat from "src/img/survey/icons/great.webp";
import IconSatisfactionExcellent from "src/img/survey/icons/excellent.webp";
import IconYesNo from "src/img/survey/icons/yes-no.webp";
import IconFeedBack from "src/img/survey/icons/feedback.webp";
import { FEATURE_FLAGS } from "src/constants/FeatureFlag";

export const EnumSurveyType = {
    RATING: "Rating",
    SATISFACTION: "Satisfaction",
    YESNO: "Yes/No",
    FEEDBACK: "Feedback",
    MULTI_TYPE: "Multi Type",
};

export const getQuestionSurveyType = (survey, surveyQuestion) => {
    if (survey?.surveyType === EnumSurveyType.MULTI_TYPE) {
        return surveyQuestion?.surveyType || "";
    }

    return survey?.surveyType || surveyQuestion?.surveyType || "";
};

export const EnumUserGroup = {
    EMPLOYEES: "Employees",
    CLIENTS: "Clients",
    PROMOTION_USERS: "Promotion Users",
    ALL_USERS: "All Users",
    SELECTED_USERS: "Selected Users",
};

export const EnumSurveyShowFrequency = {
    EVERYTIME: "Everytime",
    HOURS24: "24 hours",
    HOURS48: "48 hours"
};

export const EnumSurveyShownIn = {
    QUOTE_SCREEN: "Quotes Screen",
    NOTICEBOARD_SCREEN: "Noticeboard Screen",
    GOAL_TRACK_SCREEN: "Goal Track Screen",
    ARTICLES_SCREEN: "Articles Screen",
    PLAYLISTS_SCREEN: "Playlists Screen",
    APP_SETTINGS_SCREEN: "App Settings Screen",
};

/** **/

export const FormStep = {
    PAGE_SURVEY_NAME: 1,
    PAGE_TYPE_OF_SURVEY: 2,
    PAGE_SURVEY_DURATION: 3,
    PAGE_USER_GROUP: 4,
    PAGE_SURVEY_QUESTIONS: 5,
    PAGE_SURVEY_FREQUENCY: 6,
    PAGE_OVERVIEW: 7,
    PAGE_CONGRATULATIONS: 8
};

export const ErrorList = {
    UNKNOWN: 0,
    EMPTY_SURVEY_NAME: 1,
    EMPTY_SURVEY_TYPE: 2,
    EMPTY_USER_GROUP: 3,
    EMPTY_START_DATE: 4,
    EMPTY_FINISH_DATE: 5,
    EMPTY_QUESTION: 6,
    EMPTY_SHOW_IN: 7,
    EMPTY_SHOW_FREQUENCY: 8,
    DATE_START_DATE_INVALID: 9,
    DATE_FINISH_DATE_INVALID: 10,
    DATE_START_FORMAT_INVALID: 11,
    DATE_FINISH_FORMAT_INVALID: 12,
    DATE_RANGE_INVALID: 13,
    EMPTY_POLL_QUESTION: 14,
    EMPTY_POLL_OPTIONS: 15,
    EMPTY_POLL_PARTICIPANTS: 16,
    EMPTY_SELECTED_USERS: 17,
    QUESTION_LIMIT_REACHED: 18,
    QUESTION_MIN_REQUIRED: 19,
    SURVEY_QUESTION_IMMUTABLE: 20,
    EMPTY_QUESTION_SURVEY_TYPE: 21
};

export const returnErrorMessages = {
    [ErrorList.DATE_START_DATE_INVALID]: "Please provide a day in the future for start date",
    [ErrorList.DATE_FINISH_DATE_INVALID]: "Please provide a day in the future for finish date",
    [ErrorList.DATE_RANGE_INVALID]: "Please provide that start date is not greater finish date",
    [ErrorList.QUESTION_LIMIT_REACHED]: "Please limit the number of questions to a maximum of 3",
    [ErrorList.QUESTION_MIN_REQUIRED]: "Please provide at lease one question",
    [ErrorList.SURVEY_QUESTION_IMMUTABLE]: "Questions and response types may not be modified after the survey becomes active.",
    [ErrorList.EMPTY_QUESTION_SURVEY_TYPE]: "Please select a response type for each question."
};

export const ErrorStrings = {
    
    [ErrorList.UNKNOWN]: "* Error unknown. Please contact support@memotivationapp.com",
    [ErrorList.EMPTY_SURVEY_NAME]: "* Please enter a survey name ",
    [ErrorList.EMPTY_SURVEY_TYPE]: "* Please select a survey type ",
    [ErrorList.EMPTY_USER_GROUP]: "* Please select a user group ",
    [ErrorList.EMPTY_START_DATE]: "* Please enter a start date ",
    [ErrorList.EMPTY_FINISH_DATE]: "* Please enter a finish date ",
    [ErrorList.EMPTY_QUESTION]: "* Please enter a question for Question {number}",
    [ErrorList.QUESTION_LIMIT_REACHED]: "* " + returnErrorMessages[ErrorList.QUESTION_LIMIT_REACHED],
    [ErrorList.QUESTION_MIN_REQUIRED]: "* " + returnErrorMessages[ErrorList.QUESTION_MIN_REQUIRED],
    [ErrorList.EMPTY_SHOW_IN]: "* Please select a screen to show the survey",
    [ErrorList.EMPTY_SHOW_FREQUENCY]: "* Please select how often to show the survey",

    [ErrorList.DATE_START_DATE_INVALID]: "* " + returnErrorMessages[ErrorList.DATE_START_DATE_INVALID],
    [ErrorList.DATE_FINISH_DATE_INVALID]: "* " + returnErrorMessages[ErrorList.DATE_FINISH_DATE_INVALID],
    [ErrorList.DATE_RANGE_INVALID]: "* Please provide that finish date is ahead from start date",
    [ErrorList.EMPTY_POLL_QUESTION]: "* Please provide a poll question",
    [ErrorList.EMPTY_POLL_OPTIONS]: "* Please provide at least two options",
    [ErrorList.EMPTY_POLL_PARTICIPANTS]: "* Please select at least 1 participant for this poll",
    [ErrorList.EMPTY_SELECTED_USERS]: "* Please select at least a single user from the Users List",
    [ErrorList.SURVEY_QUESTION_IMMUTABLE]: "* " + returnErrorMessages[ErrorList.SURVEY_QUESTION_IMMUTABLE],
    [ErrorList.EMPTY_QUESTION_SURVEY_TYPE]: "* " + returnErrorMessages[ErrorList.EMPTY_QUESTION_SURVEY_TYPE],
};

/** How It Works*/
export const HowItWorksStep = {
    PAGE_IN_APP: 1,
    PAGE_SURVEY_INSIGHT: 2,
};

export const surveyTypeOptions = [
    { value: EnumSurveyType.RATING, label: "User Rating Survey", icon: IconRating },
    { value: EnumSurveyType.SATISFACTION, label: "User Satisfaction Survey", icons: [IconSatisfactionBad, IconSatisfactionPoor, IconSatisfactionOk, IconSatisfactionGreat, IconSatisfactionExcellent] },
    { value: EnumSurveyType.YESNO, label: "User Yes/No Survey", icon: IconYesNo },
    { value: EnumSurveyType.FEEDBACK, label: "User Feedback Survey", icon: IconFeedBack },
    { value: EnumSurveyType.MULTI_TYPE, label: "Multi Type Survey", icons: [IconSatisfactionExcellent, IconRating, IconYesNo, IconFeedBack] },
];

export const surveyQuestionTypeOptions = surveyTypeOptions.filter(option => option.value !== EnumSurveyType.MULTI_TYPE);

export const surveyUserGroupOptions = [
    { value: EnumUserGroup.ALL_USERS, label: "All Users" },
    { value: EnumUserGroup.CLIENTS, label: "Clients" },
    { value: EnumUserGroup.EMPLOYEES, label: "Employees" },
    { value: EnumUserGroup.SELECTED_USERS, label: "Selected Users" },
];

export const surveyShowInOptions = [
    {
        value: EnumSurveyShownIn.QUOTE_SCREEN,
        label: "Quotes Screen",
        feature: FEATURE_FLAGS.QUOTES,
    },
    {
        value: EnumSurveyShownIn.NOTICEBOARD_SCREEN,
        label: "Noticeboard Screen",
        feature: FEATURE_FLAGS.NOTICEBOARD,
    },
    {
        value: EnumSurveyShownIn.GOAL_TRACK_SCREEN,
        label: "Goal Track Screen",
        feature: FEATURE_FLAGS.GOAL_TRACKER,
    },
    {
        value: EnumSurveyShownIn.ARTICLES_SCREEN,
        label: "Articles Screen",
        feature: FEATURE_FLAGS.QUOTES,
    },
    {
        value: EnumSurveyShownIn.PLAYLISTS_SCREEN,
        label: "Playlists Screen",
        feature: FEATURE_FLAGS.PLAYLISTS,
    },
    {
        value: EnumSurveyShownIn.APP_SETTINGS_SCREEN,
        label: "App Settings Screen",
        feature: FEATURE_FLAGS.MY_ME_APP,
    },
];

export const surveyFrequencyOptions = [
    { value: EnumSurveyShowFrequency.EVERYTIME, label: "Every time the app is launched" },
    { value: EnumSurveyShowFrequency.HOURS24, label: "24 after user has seen the survey" },
    { value: EnumSurveyShowFrequency.HOURS48, label: "48 after user has seen the survey" },
];

export const surveyRatingRotation = {
    Five: 175,
    One: 5, 
};

export const FormType = {
    SURVEYS: "Surveys",
    POLLS: "Polls"
};

export const PollVisibilityType = {
    EMPLOYEES: "All Employees",
    CLIENTS: "All Clients"
};

export const getAvailableSurveyShowInOptions = (featureFlags = []) => {
    const flags = new Set(featureFlags);

    return surveyShowInOptions.filter(option => {
        if (!option.feature) return true;
        return flags.has(option.feature);
    });
};

export const hasFeature = (featureFlags = [], feature) =>
    Array.isArray(featureFlags) && featureFlags.includes(feature);
